import React from "react";

export default function ComingSoon() {
  return (
    <div className="h-full w-full flex items-center justify-center">
      <h1 className="font-bold text-4xl">COMING SOON</h1>
    </div>
  );
}
